
import {Component} from 'vue-property-decorator'
import BaseFlow from '@/views/Flows/BaseFlow.vue'
import {Action} from 'vuex-class'

@Component({})
export default class FlowBooking extends BaseFlow {
  @Action('refreshHistory') public refreshHistory!: () => void

  public exitBack() {
    // this.getPersistent()
    if (this.$route.name !== 'activities') {
      this.$router.replace({name: 'activities'})
    }
    this.$popup.close()
  }

  public exitForward() {
    this.refreshHistory()
    if (this.$route.name !== 'home') {
      this.$router.push({name: 'home'})
    }
    this.$popup.close()
  }

  public getName(): string {
    return 'rent'
  }

  protected beforeDestroy() {
    this.purgeFlow('rent')
  }
}
